import React, { useContext } from 'react';

export const ComponentLoadingStatus = {
  LOADED: 'Loaded',
  NOT_LOADED: 'Not loaded',
  UNSET: 'Unset', // We don't care about the value
  LOADING: 'Loading',
};

const defaultElementStatus = {
  status: ComponentLoadingStatus.NOT_LOADED,
  reason: null,
};

// Signal to know whether core elements are finished rendering
export const PreviewPageContext = React.createContext({
  elementsLoadingStatus: {
    coverImage: defaultElementStatus,
    description: defaultElementStatus,
  },
  updateElementsLoadingStatus: () => { },
});

export const usePreviewPageContext = () => useContext(PreviewPageContext);
